import React, { useState, useContext, useEffect } from 'react'
import {
  Form,
  Switch,
  Divider,
} from 'antd'

import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'

import PassForm from './SubscriptionForm'
import './index.styl'

const { Item, List } = Form

const Subscriptions = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [subscriptionsSwitch, setSubscriptionsSwitch] = useState(false)
  const [subscriptions, setSubscriptions] = useState(form.getFieldValue('subscriptions') || [])
  // const mobile = window.innerWidth <= 730
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (!!currentPageDetails?.subscriptions?.length) {
      setSubscriptionsSwitch(true)
      setSubscriptions(currentPageDetails.subscriptions)
    }
  }, [currentPageDetails])

  useEffect(() => {
    if (!subscriptions.length) {
      setSubscriptionsSwitch(false)
      form.setFieldsValue({
        subscriptionsSwitch: false,
      })
    }
  }, [subscriptions, form])

  const handleSwitchChange = checked => {
    setSubscriptionsSwitch(checked)
    if (checked && !subscriptions.length) {
      const newSubscriptions = [{}]
      setSubscriptions(newSubscriptions)
      form.setFieldsValue({
        subscriptions: newSubscriptions,
      })
    }
  }

  const getSubscriptionsData = idx => {
    return subscriptions[idx]
  }

  return (
    <div className='sessionAndPassesWrapper'>
      <div className={subscriptionsSwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='subscriptionsSwitch' valuePropName='checked' className='item'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Subscription Passes</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {subscriptionsSwitch && (
        <List name='subscriptions'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <PassForm
                  currentPageDetails={currentPageDetails}
                  form={form}
                  categoryData={getSubscriptionsData(fieldKey)}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedSubscriptions = form.getFieldValue('subscriptions')
                    setSubscriptions(updatedSubscriptions)
                    if (updatedSubscriptions.length === 0) {
                      form.setFieldsValue({
                        subscriptionsSwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory'
                className='addCategoryBtn'
                onClick={() => {
                  add()
                  const updatedSubscriptions = form.getFieldValue('subscriptions')
                  setSubscriptions(updatedSubscriptions)
                }}
              >Add Another Subscription Pass
              </div>
            </>
          )}
        </List>
      )}
      <Divider />
    </div>
  )
}

export default Subscriptions
